export function getWindow(): Window | undefined {
    if (typeof window !== 'undefined') {
        return window;
    }
    return undefined;
}